<div>
  <div class="header-controls">
    <h3><img src="/assets/images/iconEnroll.svg" /> Management User </h3>
  </div>
  <div>
    <div class="section-header padding-bottom-0">
      <h5 class="section-header-detailed">
        <fa-icon [classes]="['print-hide']" [icon]="schoolUsersIcon"></fa-icon> {{ formTitle }}
      </h5>
    </div>
  </div>
  <div class="boxed-content">
    @if (message) {
      <div id="user-list-message" class="alert message" style="margin-top: 10px ;" [ngClass]="{ 'alert-danger': messageStatus === 'error', 'alert-success' : messageStatus === 'success', 'alert-warning': messageStatus === 'warning' }">
        <div class="icon">
          @if (messageStatus === 'success') {
            <fa-icon [icon]="successIcon"></fa-icon>
          } @else if (messageStatus === 'warning') {
            <fa-icon [icon]="warningIcon"></fa-icon>
          } @else if (messageStatus === 'error') {
            <fa-icon [icon]="errorIcon"></fa-icon>
          }
        </div>
        <div>
          <div class="bold">{{ messageTitle }}</div>
          <div [innerHTML]="message"></div>
        </div>
      </div>
    }
    <div class="padding-15">
      <form [formGroup]="schoolUsersForm" (ngSubmit)="saveSchoolUsers()">
        <div formArrayName="users">
          @for (userForm of users.controls ; track $index ; let idx = $index, first =  $first, last = $last) {
            <div [formGroup]="userForm">
              <div class="row align-items-center">
                <div class="form-group required col-md-2 padding-bottom-10">
                  <label class="control-label">First Name*</label>
                  <input type="text" class="form-control" placeholder="First Name" formControlName="firstName"/>
                  @if (userForm.get('firstName')?.invalid && (userForm.get('firstName')?.dirty || userForm.get('firstName')?.touched)) {
                    <div class="help-block small-text">
                      @if (userForm.get('firstName')?.errors?.['required'] || userForm.get('firstName')?.errors?.['maxlength']) {
                        <div>
                          <fa-icon [icon]="errorIcon"></fa-icon> Please enter a first name (50 characters maximum)
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="form-group required col-md-2 padding-bottom-10">
                  <label class="control-label">Last Name*</label>
                  <input type="text" class="form-control" placeholder="Last Name" formControlName="lastName"/>
                  @if (userForm.get('lastName')?.invalid && (userForm.get('lastName')?.dirty || userForm.get('lastName')?.touched)) {
                    <div class="help-block small-text">
                      @if (userForm.get('lastName')?.errors?.['required'] || userForm.get('lastName')?.errors?.['maxlength']) {
                        <div>
                          <fa-icon [icon]="errorIcon"></fa-icon> Please enter a last name (50 characters maximum)
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="form-group required col-md-3 padding-bottom-10">
                  <label class="control-label">Email*</label>
                  <input type="text" class="form-control" placeholder="Email" formControlName="email"/>
                  @if (userForm.get('email')?.invalid && (userForm.get('email')?.dirty || userForm.get('email')?.touched)) {
                    <div class="help-block small-text">
                      @if (userForm.get('email')?.errors?.['required'] || userForm.get('email')?.errors?.['email']) {
                        <div>
                          <fa-icon [icon]="errorIcon"></fa-icon> Please enter a valid email address
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="form-group required col-md-3 padding-bottom-10">
                  <label class="control-label">User Role*</label>
                  <select class="form-control form-select" formControlName="userRole">
                    @for(userRole of userRoles ; track $index) {
                      <option value="{{userRole.key}}">{{userRole.label}}</option>
                    }
                  </select>
                </div>
                <div class="col-md-2 flex padding-top-10 gap-2">
                  @if(last && !editMode) {
                    <button type="button" class="btn btn-success" (click)="addSchoolUser()"><fa-icon [icon]="addIcon"></fa-icon></button>
                  }
                  @if(!first && !editMode ) {
                    <button type="button" class="btn btn-danger" (click)="removeSchoolUser(idx)"><fa-icon [icon]="trashIcon"></fa-icon></button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (!editMode) {
          <div class="row">
            <div class="form-group">
              <input type="checkbox" formControlName="notify" id="notify" />
              <label class="control-label" for="notify" style="padding-left: 5px ;">Email user account information</label>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-md-12 padding-left-0">
            <button type="submit" class="btn btn-success" [disabled]="schoolUsersForm.invalid || saving">
              @if (saving) {
                <fa-icon [icon]="loadingIcon" [spin]="true"></fa-icon>
              } @else if (editMode){
                <fa-icon [icon]="editIcon"></fa-icon>
              } @else {
                <fa-icon [icon]="createIcon"></fa-icon>
              }
              @if (editMode) {
                Save Changes
              } @else {
                Create {{ users.length === 1 ? '1 Management User' : users.length + ' Management Users' }}
              }
            </button>
            or <a routerLink="/users/list">Return to List</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
